import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ButtonStandardType } from '../../button/ButtonStandard/ButtonStandard';
import { DropdownButton, DropdownButtonProps } from '../../button/DropdownButton/DropdownButton';
import { useScreenSm } from '../../hooks/mediaQueries/useScreenSm';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { IconDeprecated, IconType } from '../IconDeprecated/IconDeprecated';
export type CreateEntityButtonProps<TDropdownItem> = PropsWithoutChildren<Omit<DropdownButtonProps<TDropdownItem>, 'items' | 'getDisplayTextOfItem' | 'getKeyOfItem' | 'onItemSelected' | 'type'>> & {
  readonly text: string;
  readonly dropdownItems: Array<TDropdownItem>;
  readonly getDropdownItemDisplayText: (item: TDropdownItem) => string;
  readonly getDropdownItemKey: (item: TDropdownItem) => string;
  readonly onCreateEntity: (item: TDropdownItem | null) => void;
};
export const CreateEntityButton = React.memo(props => {
  const $ = _c(20);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let dropdownItems;
  let getDropdownItemDisplayText;
  let getDropdownItemKey;
  let onCreateEntity;
  let remainingProps;
  let text;
  if ($[2] !== t0) {
    ({
      text,
      dropdownItems,
      getDropdownItemDisplayText,
      getDropdownItemKey,
      onCreateEntity,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = dropdownItems;
    $[4] = getDropdownItemDisplayText;
    $[5] = getDropdownItemKey;
    $[6] = onCreateEntity;
    $[7] = remainingProps;
    $[8] = text;
  } else {
    dropdownItems = $[3];
    getDropdownItemDisplayText = $[4];
    getDropdownItemKey = $[5];
    onCreateEntity = $[6];
    remainingProps = $[7];
    text = $[8];
  }
  const screenSm = useScreenSm();
  const t1 = screenSm ? text : null;
  const t2 = dropdownItems.length > 1;
  let t3;
  if ($[9] !== screenSm || $[10] !== t2) {
    t3 = <IconDeprecated name="plus-circle" type={IconType.Light} hasTextOnLeftSide={screenSm} hasTextOnRightSide={t2} />;
    $[9] = screenSm;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== dropdownItems || $[13] !== getDropdownItemDisplayText || $[14] !== getDropdownItemKey || $[15] !== onCreateEntity || $[16] !== remainingProps || $[17] !== t1 || $[18] !== t3) {
    t4 = <DropdownButton {...remainingProps} items={dropdownItems} getDisplayTextOfItem={getDropdownItemDisplayText} getKeyOfItem={getDropdownItemKey} onItemSelected={onCreateEntity} type={ButtonStandardType.Primary}>{t1}{t3}</DropdownButton>;
    $[12] = dropdownItems;
    $[13] = getDropdownItemDisplayText;
    $[14] = getDropdownItemKey;
    $[15] = onCreateEntity;
    $[16] = remainingProps;
    $[17] = t1;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}) as <TDropdownItem>(props: CreateEntityButtonProps<TDropdownItem>) => React.JSX.Element;